var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", [_c("a-form", {
    attrs: {
      form: _vm.form
    }
  }, [_c("CardItem", {
    attrs: {
      title: "选择分类",
      layout: "vertical"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: "请选择分类"
    },
    on: {
      change: _vm.handleCategoryChange
    },
    model: {
      value: _vm.selectedCategoryType,
      callback: function callback($$v) {
        _vm.selectedCategoryType = $$v;
      },
      expression: "selectedCategoryType"
    }
  }, _vm._l(_vm.categorys, function (item, i) {
    return _c("a-select-option", {
      key: i,
      attrs: {
        value: item.id
      }
    }, [_vm._v(" " + _vm._s(item.settingName) + " ")]);
  }), 1)], 1), _c("CardItem", {
    attrs: {
      title: "图片",
      layout: "vertical"
    }
  }, [_c("FileUpload", {
    attrs: {
      list: _vm.list
    },
    on: {
      success: function success(val) {
        return _vm.handleImgSuccess(val);
      },
      delete: _vm.handleImg
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "一级菜单字体色"
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.firstColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "firstColor", $$v);
      },
      expression: "value.firstColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "一级菜单选中颜色"
    }
  }, [_c("ColorPicker", {
    model: {
      value: _vm.value.firstCheckColor,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "firstCheckColor", $$v);
      },
      expression: "value.firstCheckColor"
    }
  })], 1), _c("CardItem", {
    attrs: {
      title: "文本大小",
      layout: "vertical"
    }
  }, [_c("InputBar", {
    attrs: {
      min: 12,
      max: 80,
      suffix: "px"
    },
    model: {
      value: _vm.value.textSize,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "textSize", $$v);
      },
      expression: "value.textSize"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };